import React, { Component } from 'react';
import _ from 'lodash';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { publish } from '@jutro/events';
import { RetrieveQuoteComponent } from 'wmic-components-qnb-common-react';
import { WMICProgressModal } from 'gw-capability-quoteandbind-common-react';
import { WMICTopics } from 'wmic-portals-utils-js';
import { TranslatorContext } from '@jutro/locale';
import styles from './WMICRetrievePage.module.scss';
import metadata from './WMICRetrievePage.metadata.json5';

class WMICRetrievePage extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        location: PropTypes.shape({
            search: PropTypes.string
        }).isRequired
    };

    state = {
        formData: {
            lobCategory: 'personal'
        },
        isLoading: false,
        modalProps: {}
    };

    componentDidMount() {
        // Update persisted flow value since user is on retrieval path
        if (window.wins_data_layer) {
            window.wins_data_layer.flow = 'retrieval';
        }

        // Track Retrieve Quote page view for Adobe Analytics
        publish(WMICTopics.ROUTE_CHANGED, {
            page: 'insurance:renters:quote:contact retrievequote',
            subchannel2: 'quote',
            flow: 'retrieval'
        });
    }

    handleValueChange = (value, path) => {
        const { formData } = this.state;
        _.set(formData, path, value);
        this.setState({ formData });
    };

    readValue = (id, path) => {
        const { formData } = this.state;
        return _.get(formData, path);
    };

    render() {
        const { submitted, isLoading, modalProps } = this.state;
        const overrideProps = {
            '@field': {
                // apply to all fields
                onValueChange: this.handleValueChange,
                showErrors: submitted
            }
        };

        const resolvers = {
            resolveValue: this.readValue,
            resolveClassNameMap: styles,
            // added custom start/retrieve quote components
            resolveComponentMap: {
                retrieveQuoteComponent: RetrieveQuoteComponent
            },
        };
        if (isLoading) {
            return <WMICProgressModal {...modalProps} />;
        }

        return (
            <div className={styles.main}>
                <MetadataContent
                    uiProps={metadata.pageContent}
                    overrideProps={overrideProps}
                    {...resolvers} />
            </div>
        );
    }
}
export const RetrievePageComponent = WMICRetrievePage;
export default withRouter(WMICRetrievePage);
